import { useState } from 'react'

// Shown once to visitors outside Great Britain: Keyzee is a UK platform for UK
// property transactions. Non-blocking and dismissable — the country is read
// from the `kz_geo` cookie set by the geo-notice edge function, and dismissal
// is remembered in localStorage so it is not shown again.

const DISMISS_KEY = 'kz:geo-notice-dismissed'
const ALLOWED_COUNTRY = 'GB'

function readCountry() {
  try {
    const match = document.cookie.match(/(?:^|;\s*)kz_geo=([^;]+)/)
    return match ? decodeURIComponent(match[1]) : ''
  } catch {
    return ''
  }
}

function wasDismissed() {
  try {
    return localStorage.getItem(DISMISS_KEY) === 'true'
  } catch {
    return false
  }
}

const GeoNotice = () => {
  const [dismissed, setDismissed] = useState(() => wasDismissed())
  const [country] = useState(() => readCountry())

  // Only nag visitors with a resolved, non-GB country who haven't dismissed it.
  const outsideUK = Boolean(country) && country !== ALLOWED_COUNTRY
  if (dismissed || !outsideUK) return null

  const handleDismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, 'true')
    } catch {
      /* ignore */
    }
    setDismissed(true)
  }

  return (
    <div className="geo-notice" role="dialog" aria-labelledby="geo-notice-title">
      <div className="geo-notice__body">
        <h2 id="geo-notice-title" className="geo-notice__title">
          Keyzee is a UK platform
        </h2>
        <p className="geo-notice__text">
          Keyzee is built for buying and selling homes in the United Kingdom, and all
          transactions are UK-based. You&rsquo;re welcome to browse, but our services are
          only available for UK property.
        </p>
      </div>
      <button
        type="button"
        className="primary-button geo-notice__dismiss"
        onClick={handleDismiss}
      >
        Got it
      </button>
    </div>
  )
}

export default GeoNotice
